import { COLORS } from '.';

export const phrasesTooltipStyles = {
  fontFamily: 'Lexend',
  boxShadow: '1px 1px 4px 0 rgba(0, 0, 0, 0.35)',
  color: COLORS.black,
};

export const phrasesTooltipContent = 'Prepositional, adverbial or adjectival';

export const exemplarColoredTooltipStyles = { width: '100%', padding: '15px 0 15px 0' };
